import React from "react";
import { Redirect } from "react-router-dom";

// Dashboard
import Dashboard from "../pages/Dashboard/index";

// Authentication related pages
import Login from "../pages/Authentication/Login";
import Logout from "../pages/Authentication/Logout";

//  // Inner Authentication
import Login1 from "../pages/AuthenticationInner/Login";
import Recoverpw from "../pages/AuthenticationInner/Recoverpw";
import LockScreen from "../pages/AuthenticationInner/auth-lock-screen";

// Profile
import UserProfile from "../pages/Authentication/user-profile";

//page
import Users from "../pages/Users";
import Notification from "../pages/Notification";
import TenderMaster from "../pages/tender-master/AddTender";
import ViewTender from "../pages/tender-master/ViewTender";
import TenderArchived from "../pages/tender-master/TenderArchived";
import JobMaster from "../pages/job-master/AddJob";
import ViewJob from "../pages/job-master/ViewJob";
import ViewArchived from "../pages/job-master/JobArchived/";
import NewsMaster from "../pages/news-master/AddNews";
import ViewNews from "../pages/news-master/ViewNews";
import InquiryMaster from "../pages/inquiry-master";
import LastUpdate from "../pages/last-update";
import Calender from "../pages/calender";
import ContactUs from "../pages/Contact";
import ContactTable from "../pages/ContactTable";

const userRoutes = [
  { path: "/dashboard", component: Dashboard },
  { path: "/users", component: Users },
  { path: "/tender-master", component: TenderMaster },
  { path: "/view-tender", component: ViewTender },
  { path: "/archive-tender", component: TenderArchived },
  { path: "/job-master", component: JobMaster },
  { path: "/view-job", component: ViewJob },
  { path: "/archive-job", component: ViewArchived },
  { path: "/news-master", component: NewsMaster },
  { path: "/view-news", component: ViewNews },
  { path: "/inquiry-master", component: InquiryMaster },
  { path: "/last-update", component: LastUpdate },
  { path: "/calender", component: Calender },
  { path: "/contact-table", component: ContactTable },
  { path: "/contact-us", component: ContactUs },

  //Notification
  { path: "/notification", component: Notification },
  // //profile
  { path: "/profile", component: UserProfile },

  // { path: "/panchang", component: Panchang },

  // this route should be at the end of all other routes
  { path: "/", exact: true, component: () => <Redirect to="/dashboard" /> },
];

const authRoutes = [
  { path: "/logout", component: Logout },
  { path: "/login", component: Login },
  // { path: "/pages-404", component: Pages404 },
  // { path: "/pages-500", component: Pages500 },

  // Authentication Inner
  { path: "/pages-login", component: Login1 },
  { path: "/page-recoverpw", component: Recoverpw },
  { path: "/auth-lock-screen", component: LockScreen },
];

export { userRoutes, authRoutes };
